/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/booking/new-feature-tooltip.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from 'ngx-cookie/src/cookie.service';
import * as import7 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import8 from '../../../../../public/upgrade/feature/booking/booking.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/http/src/http';
import * as import12 from '@angular/core/src/linker/component_factory';
import * as import13 from 'ngx-cookie/src/cookie-options-provider';
import * as import14 from '../../../../../public/upgrade/core/mobile.service';
export class Wrapper_NewFeatureTooltipComponent {
  /*private*/ _eventHandler:Function;
  context:import0.NewFeatureTooltipComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.NewFeatureTooltipComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_title(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.title = currValue;
      this._expr_0 = currValue;
    }
  }
  check_body(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.body = currValue;
      this._expr_1 = currValue;
    }
  }
  check_button(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.button = currValue;
      this._expr_2 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_NewFeatureTooltipComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_NewFeatureTooltipComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.NewFeatureTooltipComponent>;
  _CookieService_0_3:import6.CookieService;
  _NewFeatureTooltipComponent_0_4:Wrapper_NewFeatureTooltipComponent;
  __GAService_0_5:import7.GAService;
  __BookingService_0_6:import8.BookingService;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_NewFeatureTooltipComponent_Host0,renderType_NewFeatureTooltipComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  get _GAService_0_5():import7.GAService {
    if ((this.__GAService_0_5 == null)) { (this.__GAService_0_5 = new import7.GAService()); }
    return this.__GAService_0_5;
  }
  get _BookingService_0_6():import8.BookingService {
    if ((this.__BookingService_0_6 == null)) { (this.__BookingService_0_6 = new import8.BookingService(this.injectorGet(import11.Http,this.parentIndex))); }
    return this.__BookingService_0_6;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'new-feature-tooltip',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_NewFeatureTooltipComponent0(this.viewUtils,this,0,this._el_0);
    this._CookieService_0_3 = new import6.CookieService(this.injectorGet(import13.CookieOptionsProvider,this.parentIndex));
    this._NewFeatureTooltipComponent_0_4 = new Wrapper_NewFeatureTooltipComponent(this.injectorGet(import14.MobileService,this.parentIndex),this._CookieService_0_3);
    this.compView_0.create(this._NewFeatureTooltipComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import12.ComponentRef_<any>(0,this,this._el_0,this._NewFeatureTooltipComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.CookieService) && (0 === requestNodeIndex))) { return this._CookieService_0_3; }
    if (((token === import0.NewFeatureTooltipComponent) && (0 === requestNodeIndex))) { return this._NewFeatureTooltipComponent_0_4.context; }
    if (((token === import7.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_5; }
    if (((token === import8.BookingService) && (0 === requestNodeIndex))) { return this._BookingService_0_6; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._NewFeatureTooltipComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    if (!throwOnChange) { this._NewFeatureTooltipComponent_0_4.context.ngAfterContentChecked(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const NewFeatureTooltipComponentNgFactory:import12.ComponentFactory<import0.NewFeatureTooltipComponent> = new import12.ComponentFactory<import0.NewFeatureTooltipComponent>('new-feature-tooltip',View_NewFeatureTooltipComponent_Host0,import0.NewFeatureTooltipComponent);
const styles_NewFeatureTooltipComponent:any[] = ([] as any[]);
var renderType_NewFeatureTooltipComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_NewFeatureTooltipComponent,{});
export class View_NewFeatureTooltipComponent0 extends import2.AppView<import0.NewFeatureTooltipComponent> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  /*private*/ _expr_26:any;
  /*private*/ _expr_27:any;
  /*private*/ _expr_28:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_NewFeatureTooltipComponent0,renderType_NewFeatureTooltipComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
    this._expr_26 = import1.UNINITIALIZED;
    this._expr_27 = import1.UNINITIALIZED;
    this._expr_28 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','info-tooltip eva-3-tooltip -top pull-right -white -close -show-tooltip','id','info-tooltip'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_1,'div',new import3.InlineArray2(2,'class','tooltip-container'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_3,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_3,'i',new import3.InlineArray2(2,'class','tooltip-close eva-3-icon-close'),(null as any));
    this._text_8 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_3,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                                        ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_9,'h6',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_9,'\n                                        ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_9,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_9,'\n                                        ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_9,'button',new import3.InlineArray2(2,'class','info-button eva-3-btn-ghost -md -darken'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                                            ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'',(null as any));
    this._text_21 = this.renderer.createText(this._el_17,'\n                                        ',(null as any));
    this._text_22 = this.renderer.createText(this._el_9,'\n                                    ',(null as any));
    this._text_23 = this.renderer.createText(this._el_3,'\n    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_1,'\n',(null as any));
    this._text_25 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_7,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_7));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_17,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_17));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_26:any = import3.inlineInterpolate(1,'',this.context.title,'');
    if (import3.checkBinding(throwOnChange,this._expr_26,currVal_26)) {
      this.renderer.setText(this._text_12,currVal_26);
      this._expr_26 = currVal_26;
    }
    const currVal_27:any = import3.inlineInterpolate(1,'',this.context.body,'');
    if (import3.checkBinding(throwOnChange,this._expr_27,currVal_27)) {
      this.renderer.setText(this._text_15,currVal_27);
      this._expr_27 = currVal_27;
    }
    const currVal_28:any = import3.inlineInterpolate(1,'',this.context.button,'');
    if (import3.checkBinding(throwOnChange,this._expr_28,currVal_28)) {
      this.renderer.setText(this._text_20,currVal_28);
      this._expr_28 = currVal_28;
    }
  }
  handleEvent_7(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.closeOneTimeTooltip($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_17(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.closeOneTimeTooltip($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/booking/new-feature-tooltip.component.ngfactory.ts